
if (!window.Eurus.loadedScript.has('estimate-shipping-rate.js')) {
  window.Eurus.loadedScript.add('estimate-shipping-rate.js');
  
  /* NZS-ALPINE-BOOT (2026-07-31): run now, not next frame - vendors.js dispatches alpine:init before the next paint, so an rAF-deferred listener randomly loses its registrations. Same fix as theme.js. */(function(_cb){_cb()})(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xEstimateShipping", (el, single, multiple, noRates) => ({
        countryEl: el.querySelector('.country-select'),
        provinceEl: el.querySelector('.province-select'),
        provinceContainer: el.querySelector('.province-container'),
        zip: el.querySelector('.zip-input'),
        rates: el.querySelector('.rates'),
        errors: el.querySelector('.errors'),
        loadingShipping: false,
        rates_heading: '',
        rates_text: '',
        errors_message: '',
        cachedData: [],
        cachedResponse:[],
        load() {
          this.setSelectedOption(this.countryEl, this.countryEl.dataset.default);
    
          if (this.provinceEl.dataset.default && this.provinceEl.options.length > 0) {
            this.setSelectedOption(this.provinceEl, this.provinceEl.dataset.default);
          }
    
          this.handleCountryChange();
          this.countryEl.addEventListener('change', this.handleCountryChange.bind(this));
        },
        
        handleCountryChange() {
          const selectedOption = this.countryEl.options[this.countryEl.selectedIndex];
          const provinces = JSON.parse(selectedOption.dataset.provinces);
    
          Array.from(this.provinceEl.options).forEach((option) => option.remove());
    
          if (provinces && provinces.length === 0) {
            this.provinceContainer.hidden = true;
          } else {
            provinces.forEach((province) => {
              const option = document.createElement('option');
              [option.value, option.innerHTML] = province;
              this.provinceEl.appendChild(option);
            });
    
            this.provinceContainer.hidden = false;
          }
        },

        setSelectedOption(selector, value) {
          Array.from(selector.options).forEach((option, index) => {
            if (option.value === value || option.innerHTML === value) {
              selector.selectedIndex = index;
            }
          });
        },

        async submit(e) {
          
          e?.preventDefault();
    
          this.errors.classList.add('hidden');
          this.rates.classList.add('hidden');
          
          const params = `shipping_address[zip]=${this.zip.value}&shipping_address[country]=${this.countryEl.value}&shipping_address[province]=${this.provinceEl.value}`;
    
          if (this.cachedData[params]) {
            if ( this.cachedResponse[params]) {
              this.showRates(this.cachedData[params]);
            } else {
              this.showErrors(this.cachedData[params]);
            }
            return true;
          }

          this.loadingShipping = true;
          /* NZS-RATES-RETRY (Blake 2026-07-31): this used to cache EVERY response,
             successes and failures alike. One transient 429 from Shopify ("Too many
             attempts") was therefore cached against the address and replayed on every
             later Calculate — the customer could never get a rate again without
             reloading. Now: retry transient failures with backoff, and only ever cache
             an authoritative answer (2xx, or a real 4xx that is not a rate limit). */
          const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
          const MAX = 3;
          try {
            let response, data, attempt = 0;
            while (true) {
              attempt++;
              response = await fetch(`${Shopify.routes.root}cart/shipping_rates.json?${params}`);
              const raw = await response.text();
              try { data = JSON.parse(raw); } catch (e) { data = null; }

              const transient = response.status === 429 || response.status >= 500 || (!response.ok && data === null);
              if (!transient || attempt >= MAX) break;
              const ra = parseInt(response.headers.get('Retry-After'), 10);
              await sleep(ra > 0 ? Math.min(ra * 1000, 5000) : 600 * Math.pow(2, attempt - 1));
            }

            if (response.ok) {
              this.showRates(data || {});
              this.cachedResponse[params] = true;
              this.cachedData[params] = data || {};
            } else if (response.status === 429 || response.status >= 500 || data === null) {
              /* transient after every retry — surface it, but NEVER cache it */
              this.showErrors({ base: ["Couldn't get rates just then. Please try again."] });
            } else {
              this.showErrors(data || {});
              this.cachedResponse[params] = false;
              this.cachedData[params] = data || {};
            }
          } catch (error) {
            this.showErrors({ base: ["Couldn't get rates just then. Please try again."] });
          } finally {
            this.loadingShipping= false;
          }
        },
    
        showRates(data) {
          const headingEl = this.rates.querySelector('.rates-heading');
    
          if (data.shipping_rates && data.shipping_rates.length) {
            this.rates_heading = data.shipping_rates.length === 1 ? single : multiple;
            let rates = '';
            
            data.shipping_rates.forEach((rate) => {
              const formattedRate = rate.price + rate.currency;
              rates += `<li class="pt-2">${rate.name}: ${formattedRate}</li>`;
            });
    
            headingEl.classList.remove('hidden');
            this.rates_text = `<ul class="list-disc pl-4">${rates}</ul>`;
          } else {
            headingEl.classList.add('hidden');
            this.rates_text = `<p class="no-rate">${noRates}</p>`;
          }
    
          this.rates.classList.remove('hidden');
        },
    
        showErrors(data) {
          let errors = '';
          Object.keys(data).forEach((key) => {
            errors += `<li>${data[key]}</li>`;
          });
    
          this.errors_message = `<ul>${errors}</ul>`;
          this.errors.classList.remove('hidden');
        }
      }));
      Alpine.store('xPopupShipping', {
        open: false
      });
    });
  });
}